import axios from 'axios';
import type { AxiosRequestHeaders } from 'axios';
import { AuthenticationService } from '../domain-services/Authentication.service';

let authenticationService: AuthenticationService | null = null;

const getAuthenticationService = () => {
	authenticationService ??= new AuthenticationService();
	return authenticationService;
};

axios.interceptors.request.use(
	async (config) => {
		const authenticationService = getAuthenticationService();
		const accessToken = authenticationService.getAccessToken();

		if (accessToken && !(config as typeof config & { skipAuth?: boolean }).skipAuth) {
			config.headers = {
				...config.headers,
				Authorization: `Bearer ${accessToken}`
			} as AxiosRequestHeaders;
		}

		return config;
	},
	(error) => Promise.reject(error)
);

axios.interceptors.response.use(
	(response) => response,
	async (error) => {
		const authenticationService = getAuthenticationService();
		const config = error?.config;
		const isPublicConfirmationRoute =
			typeof window !== 'undefined' &&
			/^\/meeting-room-manager\/confirm-reservation\/[^/]+\/?$/.test(window.location.pathname);

		if (error?.response?.status === 401 && !config?._retry && !isPublicConfirmationRoute) {
			config._retry = true;
			const result = await authenticationService.updateTokens();

			if (result?.access_token) {
				config.headers = {
					...config.headers,
					authorization: `Bearer ${result?.access_token}`
				};
			}

			return axios(config);
		}

		return Promise.reject(error);
	}
);

export const axiosPrivate = axios;
